export const CONSENT_COOKIE_NAME = 'heliguy_tracking_consent'
// The Shopify checkout (checkout.heliguy.com) reads the consent cookie, so on heliguy.com it is
// stored for the root domain. Other hosts (localhost, previews) keep a host-only cookie
export const getConsentCookieDomain = () =>
  typeof window !== 'undefined' && /(^|\.)heliguy\.com$/.test(window.location.hostname)
    ? '.heliguy.com'
    : undefined

// Dispatched on window to reopen the cookie banner (e.g. from the footer "Cookie settings" link)
export const OPEN_COOKIE_SETTINGS_EVENT = 'heliguy:open-cookie-settings'

// First-party cookies / storage keys written by tags that need consent.
// Removed when the visitor withdraws the matching consent.
export const MARKETING_COOKIE_PATTERNS = [/^_fbp$/, /^_fbc$/, /^_gcl_/, /^__oppref$/, /^__obref$/]
export const ANALYTICS_COOKIE_PATTERNS = [
  /^_ga$/,
  /^_ga_/,
  /^_gid$/,
  /^_gat/,
  /^_clck$/,
  /^_clsk$/,
  /^__kla_id$/,
]
export const MARKETING_STORAGE_PATTERNS = [
  /^_gcl_/,
  /^claydar_/,
  /^radar_/,
  /^lastExternalReferrer/,
]
export const ANALYTICS_STORAGE_PATTERNS = [
  /^_cltk$/,
  /^klaviyo/,
  /^kl-/,
  /^\$referrer$/,
  /^\$last_referrer$/,
  /^cart_first_add_/,
]
